module.exports = generateReportIds

const DEFAULT_SINCE = '2018-01-01T00:00:00.000Z'

const {createV1IdsBetweenDates} = require('../report/tools/ids')

function generateReportIds (location, service, { since = DEFAULT_SINCE, till } = {}) {
  return createV1IdsBetweenDates({locationId: location, service, startDate: since, endDate: till})
}
